import React from 'react'
import './are-you-sure.css'

export function AreYouSure(props) {
    return(
        <div className="are-you-sure-wrapper">
            <div className="are-you-sure-content">
                <p className="are-you-sure-text">Are you sure you want to remove this family?</p>
                <div className="are-you-sure-btn-no" onClick={() => props.setAreYouSure(null)}>No</div>
                <div className="are-you-sure-btn" onClick={() => props.removeTheFamily()}>Delete</div>
            </div>
        </div>
    )
}